import {
  ADD_PERSON,
  ADD_PERSON_SUCCESS,
  ADD_PERSON_FAILED,
  FETCH_PEOPLE,
  FETCH_PEOPLE_FAILED,
  FETCH_PEOPLE_SUCCESS,
  RESET_PERSON_ADDED,
  EDIT_PERSON,
  EDIT_PERSON_SUCCESS,
  EDIT_PERSON_FAILED,
  RESET_PERSON_EDITED,
  FETCH_PERSON,
  FETCH_PERSON_SUCCESS,
  FETCH_PERSON_FAILED,
  DELETE_PERSON,
  DELETE_PERSON_SUCCESS,
  DELETE_PERSON_FAILED,
  RESET_PERSON_DELETED,
  UPLOAD_PEOPLE_FROM_FILE,
  UPLOAD_PEOPLE_FROM_FILE_SUCCESS,
  UPLOAD_PEOPLE_FROM_FILE_FAILED,
  RESET_FILE_UPLOAD,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS,
  UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED,
  RESET_PEOPLE_PAGE
} from './types';

import { SIGN_OUT } from '../auth/types';

const initialState = {
  addingPerson: false,
  people: [],
  fetchingPeople: false,
  editingPerson: false,
  personAdded: false,
  personDeleted: false,
  personEdited: false,
  fetchingPerson: false,
  deletingPerson: false,
  peoplePage: 1,
  peopleLimit: 250,
  peopleFetched: false,
  totalNumberOfPeople: 0,
  numberOfPeople: 0,
  uploadedPeople: [],
  uploadingPeopleFromFile: false,
  peopleUploaded: false,
  uplodPeopleError: false,
  fileName: '',
  uploadConfirmed: false,
  query: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...initialState
      };
    case ADD_PERSON:
      return {
        ...state,
        addingPerson: true
      };
    case ADD_PERSON_SUCCESS:
      return {
        ...state,
        addingPerson: false,
        personAdded: true
      };
    case ADD_PERSON_FAILED:
      return {
        ...state,
        addingPerson: false
      };
    case RESET_PERSON_ADDED:
      return {
        ...state,
        personAdded: false
      };
    case EDIT_PERSON:
      return {
        ...state,
        editingPerson: true
      };
    case EDIT_PERSON_SUCCESS:
      return {
        ...state,
        editingPerson: false,
        personEdited: true
      };
    case EDIT_PERSON_FAILED:
      return {
        ...state,
        editingPerson: false
      };
    case RESET_PERSON_EDITED:
      return {
        ...state,
        personEdited: false
      };
    case DELETE_PERSON:
      return {
        ...state,
        deletingPerson: true
      };
    case DELETE_PERSON_SUCCESS:
      return {
        ...state,
        deletingPerson: false,
        personDeleted: true
      };
    case DELETE_PERSON_FAILED:
      return {
        ...state,
        deletingPerson: false
      };
    case RESET_PERSON_DELETED:
      return {
        ...state,
        personDeleted: false
      };
    case FETCH_PEOPLE:
      return {
        ...state,
        fetchingPeople: true,
        peopleFetched: false,
        query: action.query
      };
    case FETCH_PEOPLE_SUCCESS:
      return {
        ...state,
        fetchingPeople: false,
        people:
          action.payload.data && action.payload.data.persons
            ? action.payload.data.persons
            : [],
        numberOfPeople: action.payload.data.items || 0,
        totalNumberOfPeople: action.query
          ? state.totalNumberOfPeople
          : action.payload.data.total || 0,
        peoplePage: action.peoplePage,
        peopleFetched: true
      };
    case FETCH_PEOPLE_FAILED:
      return {
        ...state,
        fetchingPeople: false,
        peopleFetched: true
      };
    case FETCH_PERSON:
      return {
        ...state,
        fetchingPerson: true
      };
    case FETCH_PERSON_SUCCESS:
      return {
        ...state,
        fetchingPerson: false,
        person: action.payload.data || {}
      };
    case FETCH_PERSON_FAILED:
      return {
        ...state,
        fetchingPerson: false
      };

    case UPLOAD_PEOPLE_FROM_FILE:
      return {
        ...state,
        uploadingPeopleFromFile: true,
        peopleUploaded: false,
        uplodPeopleError: false
      };
    case UPLOAD_PEOPLE_FROM_FILE_CONFIRM:
      return {
        ...state,
        uploadingPeopleFromFile: true,
        uplodPeopleError: false
      };
    case UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS:
      return {
        ...state,
        uploadingPeopleFromFile: false,
        uploadConfirmed: true,
        uplodPeopleError: false
      };
    case UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED:
      return {
        ...state,
        uploadingPeopleFromFile: false,
        peopleUploaded: true,
        uplodPeopleError: true,
        uploadedPeople: [],
        uploadConfirmed: false
      };

    case UPLOAD_PEOPLE_FROM_FILE_SUCCESS:
      return {
        ...state,
        uploadingPeopleFromFile: false,
        uploadedPeople:
          action.payload.data && action.payload.data.rows
            ? action.payload.data.rows
            : state.uploadedPeople,
        peopleUploaded: true,
        uplodPeopleError: false,
        fileName: action.payload.data.fileName || state.fileName,
        uploadConfirmed: action.uploadConfirmed || false
      };
    case UPLOAD_PEOPLE_FROM_FILE_FAILED:
      return {
        ...state,
        uploadingPeopleFromFile: false,
        peopleUploaded: true,
        uplodPeopleError: true,
        uploadedPeople: []
      };
    case RESET_FILE_UPLOAD:
      return {
        ...state,
        uploadingPeopleFromFile: false,
        peopleUploaded: false,
        uplodPeopleError: false,
        uploadedPeople: [],
        fileName: '',
        uploadConfirmed: false
      };
     case RESET_PEOPLE_PAGE:
        return {
          ...state,
          groupPeoplePage:1
       };

    default:
      return state;
  }
};
